import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';

const links = [
  ['/', 'home', true],
  ['/residences', 'residences'],
  ['/sale', 'sale'],
  ['/location', 'location'],
  ['/contact', 'contact'],
];

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="header">
      <div className="header__inner">
        <Logo onClick={closeMenu} />

        <nav className={`header__nav ${isMenuOpen ? 'header__nav_open' : ''}`} aria-label="Primary navigation">
          {links.map(([to, label, end]) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `header__link ${isActive ? 'header__link_active' : ''}`}
              onClick={closeMenu}
            >
              {t(`navigation.${label}`)}
            </NavLink>
          ))}

          <NavLink className="button button_small header__book" to="/book" onClick={closeMenu}>
            {t('navigation.book')}
          </NavLink>

          <div className="language-switcher" aria-label="Language">
            {['en', 'ru'].map((item) => (
              <button
                key={item}
                type="button"
                className={language === item ? 'language-switcher__active' : ''}
                onClick={() => setLanguage(item)}
                aria-pressed={language === item}
              >
                {item.toUpperCase()}
              </button>
            ))}
          </div>
        </nav>

        <button
          type="button"
          className={`menu-button ${isMenuOpen ? 'menu-button_open' : ''}`}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((value) => !value)}
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}

export default Header;
